import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { s3Link } from "../Settings/Config";
import { showLoader, hideLoader, showAlert, isEmpty, showContaimerLoader, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "officedocument";
const modulePath = "/officedocument";
const moduleName = "Office Document";
const moduleID = 33;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        documentTitle: "",
      },
      currentFile: null,
      documentFileError: "",
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;
          const clientupdatedata = {
            documentTitle: result.documentTitle,
          };
          this.setState({
            postdata: clientupdatedata,
            currentFile: { documentName: result.documentName, documentFileName: result.documentFileName },
            pageloading: false,
          });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {};

  fieldChange = (field, value) => {
    this.setState((prev) => ({ postdata: { ...prev.postdata, [field]: value } }));
  };

  clearDocumentFileError = () => {
    if (this.state.documentFileError !== "") {
      this.setState({ documentFileError: "" });
    }
  };

  handleSubmit = () => {
    const fileInput = document.getElementById("documentFile");
    const file = fileInput?.files?.[0];
    if (!file) {
      this.setState({ documentFileError: "Document file is required" });
      return;
    }
    this.setState({ documentFileError: "" });

    showLoader("submit_frm", "class");
    const formPayload = new FormData();
    formPayload.append("documentTitle", this.state.postdata.documentTitle.toUpperCase());
    formPayload.append("documentFile", file);

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(formPayload, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            currentFile={this.state.currentFile}
                            documentFileError={this.state.documentFileError}
                            onFileChange={this.clearDocumentFileError}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { documentTitle } = props.fields;

  return {
    fields: ["documentTitle"],
    validations: {
      documentTitle: [[isEmpty, documentTitle]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation, currentFile, documentFileError, onFileChange } = this.props;
    let errMsgdocumentTitle = "";
    if ($validation.documentTitle.error.reason !== undefined) {
      errMsgdocumentTitle = $validation.documentTitle.show && <span className="error">{$validation.documentTitle.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-6">
              <label className="form-label">
                Document Title<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Document Title"
                name="documentTitle"
                value={fields.documentTitle}
                {...$field("documentTitle", (e) => onChange("documentTitle", e.target.value))}
              />
              {errMsgdocumentTitle}
            </div>
            <div className="form-group col-md-6">
              <label className="form-label">
                Document File<span className="lbl-error">*</span>
              </label>
              <input type="file" className="form-control" id="documentFile" name="documentFile" onChange={onFileChange} />
              {documentFileError !== "" && <span className="error">{documentFileError}</span>}
              {this.props.editID !== "" && currentFile && (
                <div className="mt-2">
                  Current file:{" "}
                  <a href={`${s3Link}officedoc/${currentFile.documentFileName}`} target="_blank" rel="noreferrer">
                    {currentFile.documentName}
                  </a>{" "}
                  <span className="text-muted">(selecting a new file will replace it)</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
